import TomSelect from 'tom-select'
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['button', 'source']

    cloneRow() {
        event.preventDefault()
        let configurationContainer = event.target.closest('[data-controller="configuration"]');
        let parent = configurationContainer.querySelector("#credentials-container")
        let ele = parent.children[0]
        
        let maxIndex = -1
        parent.querySelectorAll('input, select').forEach(input => {
            const match = input.name.match(/\[(\d+)\]/)
            if (match) {
                const index = parseInt(match[1])
                if (index > maxIndex) maxIndex = index
            }
        })
        let length = maxIndex + 1

        const clonedDiv = ele.cloneNode(true)
        const inputs = clonedDiv.querySelectorAll('input')
        let input1 = inputs[0]
        let input2 = inputs[1]
        let key = parent.dataset['value']
        if (input1) {
            input1.setAttribute('id', this.randStr())
            input1.value = ''
            input1.setAttribute('name', `${key}[${length}][key]`)
        } else {
            input2 = clonedDiv.querySelector('select')
            input2.setAttribute('id', this.randStr())
            input2.value = ''
            input2.setAttribute('name', `${key}[${length}][key]`)
        }

        if (input2) {
            input2.setAttribute('id', this.randStr())
            input2.value = ''
            input2.setAttribute('name', `${key}[${length}][value]`)
        } else {
            input2 = clonedDiv.querySelector('select')
            input2.setAttribute('id', this.randStr())
            input2.value = ''
            input2.setAttribute('name', `cost_allocation_filters[${length}][value]`)
        }
        clonedDiv.querySelector("#delete-button").classList.remove("hidden")
        parent.append(clonedDiv)
    }

    cloneDataRow() {
        event.preventDefault()
        let parent = document.querySelector("#data-table-container")
        let length = parent.children.length
        const cloneRow = document.querySelector("#clone-row")
        const clonedDiv = cloneRow.firstElementChild.cloneNode(true)
        clonedDiv.classList.remove('hidden')
        const childDiv = clonedDiv.querySelector("#column-data")
        const formDiv = clonedDiv.querySelector("#formula-data")
        const listDiv = clonedDiv.querySelector("#list-data")
        let inputDiv = childDiv.querySelector("#column-input")
        let apiInputDiv = childDiv.querySelector("#api-column-input")
        let checkDiv = clonedDiv.querySelector("#column-checkbox")
        let formulaDiv = clonedDiv.querySelector("#formula-checkbox")
        let defaultDiv = clonedDiv.querySelector("#default-checkbox")
        let input = inputDiv.querySelector('input')
        let apiInput = apiInputDiv?.querySelector('input');
        let checkBox = checkDiv.querySelector('input')
        let select = clonedDiv.querySelector('select')
        let formulaInput = formDiv.querySelector('input')
        let listInput = listDiv.querySelector('select')
        let checkLabel = checkDiv.querySelector("label")
        let formulaBox = formulaDiv.querySelector('input')
        let formulaLabel = formulaDiv.querySelector("label")
        let defaultBox = defaultDiv.querySelector("input")
        let defaultLabel = defaultDiv.querySelector("label")
        input.setAttribute('id', this.randStr())
        apiInput?.setAttribute('id', this.randStr())
        select.setAttribute('id', this.randStr())
        formulaInput.setAttribute('id', this.randStr())
        select.value = ''
        input.value = ''
        formulaInput.value = ''
        listInput.value = ''
        input.setAttribute('name', `custom_data[column_name][${length}]`)
        apiInput?.setAttribute('name', `custom_data[api_column_name][${length}]`)
        checkBox.setAttribute('name', `custom_data[required][${length}]`)
        checkBox.setAttribute('id', `custom_data[required][${length}]`)
        checkLabel.setAttribute('for', `custom_data[required][${length}]`)
        select.setAttribute('name', `custom_data[data_type][${length}]`)
        formulaInput.setAttribute('name', `custom_data[formula][${length}]`)
        listInput.setAttribute('name', `custom_data[list_values][${length}][]`)
        listInput.setAttribute("data-controller", "select");
        listInput.setAttribute("data-select-create-value", "true")
        formulaBox.setAttribute('id', `custom_data[formula][${length}]`)
        formulaLabel.setAttribute('for', `custom_data[formula][${length}]`)
        defaultBox.setAttribute('id', `custom_data[default_value][${length}]`)
        defaultLabel.setAttribute('for', `custom_data[default_value][${length}]`)
        parent.append(clonedDiv)
    }

    cloneSyncRow() {
        event.preventDefault()
        let parent = this.element.querySelector("#sync-credential-container")
        let ele = parent.children[0]
        let length = parent.childElementCount
        const clonedDiv = ele.cloneNode(true)
        clonedDiv.querySelectorAll('input').forEach(input => {
            input.setAttribute('id', this.randStr())
            input.value = ''
            input.setAttribute('name', `credentials[${input.dataset.name}][${length}]`)
        })
        clonedDiv.querySelector("#delete-button").classList.remove("hidden")
        parent.append(clonedDiv)
    }

    deleteRow() {
        event.preventDefault()
        event.target.closest('div').parentElement.remove()
    }

    deleteDataRow() {
        event.preventDefault()
        event.target.closest('div').parentElement.parentElement.remove()
    }

    randStr() {
        return (Math.random() + 1).toString(36).substring(7);
    }

    showList(event) {
        let parentElement = event.target.closest(".flex").parentElement
        let listElement = parentElement.querySelector("#list-data")
        if (event.target.value === "List") {
            listElement.classList.remove("hidden")
        } else {
            listElement.classList.add("hidden")
        }
    }

    showListField(event) {
        let columnId = event.target.dataset.columnId
        let listElement = document.querySelector(`#${columnId}_list_values`)
        if (event.target.value === "List") {
            listElement.classList.remove("hidden")
        } else {
            event.target.form.requestSubmit()
        }
    }

    showFormulaField(event) {
        let parentElement = event.target.closest(".flex").parentElement
        let formulaElement = parentElement.querySelector("#formula-data")
        if (event.target.checked) {
            formulaElement.classList.remove("hidden")
        } else {
            formulaElement.classList.add("hidden")
        }
    }

    submitForm(event) {
        event.target.form.requestSubmit()
    }
}




